import { useApolloClient } from '@apollo/client'
import { useEffectReducer } from 'use-effect-reducer'
import { useErrorData } from '../useErrorData'
import { getRefundEffectsMap } from './effects'
import { refundStateReducer } from './reducer'
import { RefundReducerArgs, RefundState } from './types'

export const useRefundEffectReducer = (args: RefundReducerArgs) => {
  const apolloClient = useApolloClient()
  const getErrorData = useErrorData()

  const effectReducer = useEffectReducer(
    refundStateReducer,
    // initial state
    exec => {
      exec({
        type: 'ecomRefundEffect',
      })
      return {
        status: 'refunding',
        errorMessage: undefined,
        retryable: false,
      } as RefundState
    },
    getRefundEffectsMap({
      ...args,
      apolloClient,
      getErrorData,
    })
  )

  return effectReducer
}
